import styled from 'styled-components';

export const StyledItemWithBadge = styled.div`
  position: relative;
`;

export const StyledBadgeNotification = styled.div`
  min-width: 25px;
  height: 25px;
  padding: 0 8px;
  color: ${({theme}) => theme.text.inverse};
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  white-space: nowrap;
  background: ${({theme}) => theme.button.success};
  border-radius: 14px;
  z-index: auto;
  overflow: hidden;
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-12px);
`;
